import React, { useState, useEffect } from "react";

const parentClassname = "react-form";

const GoogleAddressInput = props => {
    const componentClassname = parentClassname
        ? `${parentClassname}__field`
        : "field";
    const labelPlaceholderClassname = props.labelplaceholder
        ? `${componentClassname}__label--labelplaceholder`
        : "";

    const [isGoogleAutocompleteSetup, setIsGoogleAutocompleteSetup] = useState(
        false
    );

    // use effect for setting up google Autocomplete only once
    useEffect(() => {
        if (!isGoogleAutocompleteSetup && props.inputElement.ref.current) {
            let addressObject = null;

            // setup google autocomplete
            const autocomplete = new window.google.maps.places.Autocomplete(
                props.inputElement.ref.current,
                {
                    types: ["geocode"],
                }
            );

            // Sydney area bounds
            let circle = new window.google.maps.Circle({
                center: {
                    lat: -33.883299,
                    lng: 151.195955,
                },
                radius: 202484,
            });
            autocomplete.setBounds(circle.getBounds());

            // on google address select/change
            autocomplete.addListener("place_changed", () => {
                const selectedPlace = autocomplete.getPlace();
                if (selectedPlace) {
                    addressObject = selectedPlace;
                    setAddressValue(addressObject);
                }
            });

            // on input blur, set to selected google place or set to empty if none selected
            props.inputElement.ref.current.addEventListener("blur", e => {
                setTimeout(() => {
                    setAddressValue(addressObject);
                }, 300);
            });

            // google init complete (only run once flag)
            setIsGoogleAutocompleteSetup(true);
        }
    }, []);

    const setAddressValue = addressObject => {
        const formattedAddress = addressObject
            ? addressObject.formatted_address
            : "";

        props.inputElement.ref.current.value = formattedAddress;

        // pass back the formatted address as the text input value along with the full google address object as data
        props.onChange({
            target: {
                value: formattedAddress,
                name: props.name,
                data: addressObject,
            },
        });
    };

    return (
        <div
            className={`${componentClassname} 
                ${componentClassname}--search-select
                ${props.classes.inheritedClasses} 
                ${props.classes.isDisabled} 
                ${props.classes.isIncomplete} 
                ${props.classes.isFocused} 
                ${props.classes.hasValue}
                ${props.classes.isValid}
                ${props.classes.isInvalid}
            `}
        >
            <label htmlFor={`${props.name}-google-address-input`}>
                {/*label*/}
                {props.label ? (
                    <div
                        className={`${componentClassname}__label  ${labelPlaceholderClassname}`}
                    >
                        <div
                            className={`${componentClassname}__label__inner`}
                            id={props.accessibilityIds.label}
                            dangerouslySetInnerHTML={{
                                __html: props.label,
                            }}
                        ></div>
                    </div>
                ) : null}

                {/* hidden input value element*/}
                {props.inputElement}
            </label>

            {/*errors*/}
            {!props.hideErrors &&
            props.errors &&
            props.errors.length &&
            props.showErrors ? (
                <div className={`${componentClassname}__errors`}>
                    <div
                        className={`${componentClassname}__errors__item`}
                        id={props.accessibilityIds.error}
                        dangerouslySetInnerHTML={{
                            __html: props.errors[0],
                        }}
                    ></div>
                </div>
            ) : null}

            {/*info*/}
            {props.info ? (
                <div
                    className={`${componentClassname}__info`}
                    id={props.accessibilityIds.description}
                    dangerouslySetInnerHTML={{
                        __html: props.info,
                    }}
                ></div>
            ) : null}
        </div>
    );
};

export default GoogleAddressInput;
